<template>
    <v-container fluid fill-height>
        <v-layout>
            <DocumentDropZone/>
        </v-layout>
    </v-container>
</template>

<script>
    import {DIRECTORY_FETCH} from '../../store/actions.type'
    import DocumentDropZone from "../../components/document/DocumentDropZone";

    export default {
        name: "DocumentAdd",
        components: {
            DocumentDropZone
        },
        watch: {
            '$route': 'fetchDirectory'
        },
        mounted() {
            this.fetchDirectory();
        },
        methods: {
            /**
             * Récupère les informations sur le répertoire demandé
             */
            fetchDirectory() {
                this.$store.dispatch(DIRECTORY_FETCH, this.$route.params.slug);
            }
        }
    };
</script>
